import { AnalyticsAction } from '../../../constants';
import { SNOWPLOW_SCHEMAS } from '../../schemas';
import { createContexts } from '../../utils';

import type { SnowplowSchemaName } from '../../schemas';
import type { Context, EventDefinition } from '../../types';

export const insights_action: EventDefinition = {
  getData: (action, eventData = {}) => {
    const hasOverviewCard = eventData?.hasOverviewCard;
    const totalCardsCreated = eventData?.totalCardsCreated;
    if (action && eventData) {
      return {
        type: action,
        hasOverviewCard,
        totalCardsCreated,
      };
    }
    return action ? { type: action } : {};
  },
  addContexts: ({ action, eventData } = {}) => {
    if (action === AnalyticsAction.createInsightCard) {
      const customEventList: Context[] = [];
      if (eventData?.card) {
        if (Array.isArray(eventData.card)) {
          eventData.card.forEach((eventCard) => {
            customEventList.push({
              schema: SNOWPLOW_SCHEMAS['card_103'],
              data: eventCard,
            });
          });
        } else {
          customEventList.push({
            schema: SNOWPLOW_SCHEMAS['card_103'],
            data: eventData.card,
          });
        }
      }
      return [
        ...customEventList,
        ...createContexts(
          ['insight', 'lane', 'reviewfilter', 'insightfilter'],
          { eventData },
        ),
      ];
    }

    const contextMap: Record<string, SnowplowSchemaName[]> = {
      copyTopicSummary: ['reviewfilter'],
      updateFilter: ['reviewfilter'],
      generateSummary: ['reviewfilter'],
      pinReview: ['review'],
      unpinReview: ['review'],
      visitSource: ['review'],
      hideAspect: ['aspect'],
      unhideAspect: ['aspect'],
      sourceButtonClick: ['insight', 'reviewfilter', 'insightfilter'],
      feedback: ['insight', 'reviewfilter', 'insightfilter'],
      updateInsightFilter: ['insight', 'insightfilter'],
      createTopicSummaryCard: ['board', 'reviewfilter'],
    };

    return createContexts(contextMap[action || ''] || [], { eventData });
  },
};
